<form
    [formGroup]="mainForm"
    novalidate
    class="mx-auto"
    [ngClass]="{
        'mf-form-submited': isFormSubmited
    }"
>
    <div class="m-portlet">
        <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">Izbira termina</h3>
                </div>
            </div>
        </div>
        <div class="m-portlet__body">
            <div class="row m-row--no-padding">
                <div class="m-list-search">
                    <div class="m-list-search__results">
                        <div class="m-list-search__result-item m-input-icon">
                            <span class="m-list-search__result-item-icon">
                                <i ngbTooltip="Izvajalec storitve" class="la la-stethoscope m--font-inverse-light"></i>
                            </span>
                            <span class="m-list-search__result-item-text">
                                <div class="d-flex">
                                    <ng-select
                                        [items]="allSubcontractors"
                                        (change)="onSubConctractorChange()"
                                        bindLabel="name"
                                        tabindex="2"
                                        formControlName="subcontractor"
                                        class="w-100 mr-2"
                                    >
                                        <ng-template ng-optgroup-tmp let-item="item">
                                            {{ item.name }}
                                        </ng-template>
                                    </ng-select>
                                    <div>
                                        <a
                                            (click)="selectLogedinUser(); $event.stopPropagation()"
                                            href="#"
                                            ngbTooltip="Prijavljeni uporabnik"
                                            class="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
                                        >
                                            <i class="la la-user"></i>
                                        </a>
                                    </div>
                                </div>
                            </span>
                        </div>
                        <div *ngIf="(mainForm?.controls)['subcontractor'].errors && isFormSubmited" class="m--font-danger pl-5">
                            <small [hidden]="!(mainForm?.controls)['subcontractor'].errors.required">Izvajalec je obvezno polje.</small>
                        </div>

                        <!-- SERVICES -->

                        <ng-container *ngIf="servicesForSubc?.length > 0">
                            <div class="m-list-search__result-item m-input-icon">
                                <span class="m-list-search__result-item-icon">
                                    <i ngbTooltip="Nosilna storitev" class="la la-hand-paper-o m--font-inverse-light"></i>
                                </span>
                                <span class="m-list-search__result-item-text">
                                    <ng-select
                                        [items]="servicesForSubc"
                                        [compareWith]="equalsAnyById"
                                        bindLabel="name"
                                        tabindex="3"
                                        groupBy="type"
                                        formControlName="service"
                                    >
                                        <ng-template ng-optgroup-tmp let-item="item">
                                            {{ item.type | serviceTypePipe }}
                                        </ng-template>
                                    </ng-select>
                                </span>
                            </div>
                            <div *ngIf="(mainForm?.controls)['services']?.errors && isFormSubmited" class="m--font-danger pl-5">
                                <small [hidden]="!(mainForm?.controls)['services']?.errors.required">Storitev je obvezno polje.</small>
                            </div>
                        </ng-container>
                        <!-- ASSETS -->
                        <ng-container>
                            <div *ngIf="allAssets" class="m-list-search__result-item m-input-icon">
                                <span class="m-list-search__result-item-icon">
                                    <i ngbTooltip="Prostor izvedbe" class="la la-sign-in m--font-inverse-light"></i>
                                </span>
                                <span class="m-list-search__result-item-text">
                                    <ng-select
                                        [items]="allAssets"
                                        [compareWith]="equalsAnyById"
                                        bindLabel="name"
                                        groupBy="assetType"
                                        formControlName="asset"
                                    >
                                        <ng-template ng-optgroup-tmp let-item="item">
                                            {{ item.assetType | assetTypePipe }}
                                        </ng-template>
                                    </ng-select>
                                </span>
                            </div>
                            <div *ngIf="(mainForm?.controls)['asset']?.errors && isFormSubmited" class="m--font-danger pl-5">
                                <small [hidden]="!(mainForm?.controls)['asset']?.errors?.required">Prostor je obvezno polje.</small>
                            </div>
                        </ng-container>
                    </div>

                    <!-- DATE TIME -->

                    <div class="row m-row--no-padding">
                        <div class="m-list-search mb-2 col-sm-4 col-lg-4">
                            <div class="m-list-search__results">
                                <div class="m-list-search__result-item m-input-icon">
                                    <span class="m-list-search__result-item-icon">
                                        <i
                                            ngbTooltip="Datum termina"
                                            class="la la-calendar m--font-inverse-light"
                                            i18n-ngbTooltip="@@c735818db9ae8bc4378aca30b252cd7a9588995f"
                                        ></i>
                                    </span>
                                    <span class="m-list-search__result-item-text">
                                        <input
                                            [options]="calendarOptions"
                                            (selected)="setDate()"
                                            type="text"
                                            name="daterangeInput"
                                            daterangepicker
                                            formControlName="startDate"
                                            class="form-control m-input"
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="m-list-search mb-2 col-sm-4 col-lg-4 pl-2">
                            <div class="m-list-search__results">
                                <div class="m-list-search__result-item">
                                    <span class="m-list-search__result-item-icon">
                                        <i
                                            ngbTooltip="Ura pričeteka termina"
                                            class="la la-clock-o m--font-inverse-light"
                                            i18n-ngbTooltip="@@d479b18a8e0491c98fdf12ba231020056edccf88"
                                        ></i>
                                    </span>
                                    <span class="m-list-search__result-item-text">
                                        <input
                                            [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                                            type="text"
                                            placeholder="hh:mm"
                                            formControlName="startTime"
                                            class="form-control m-input"
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="m-list-search mb-2 col-sm-4 col-lg-4 pl-2">
                            <div class="m-list-search__results">
                                <div class="m-list-search__result-item mb-2">
                                    <span class="m-list-search__result-item-icon">
                                        <i
                                            ngbTooltip="Ura konca termina"
                                            class="la la-step-forward m--font-inverse-light"
                                            i18n-ngbTooltip="@@dae1d6238caf17d13f244ce600e7557c82d2fc82"
                                        ></i>
                                    </span>
                                    <span class="m-list-search__result-item-text">
                                        <input
                                            [textMask]="{ mask: timeInputMask, keepCharPositions: true }"
                                            type="text"
                                            placeholder="hh:mm"
                                            formControlName="endTime"
                                            class="form-control m-input"
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button (click)="activeModal.close('Close click')" type="button" class="ml-auto btn m-btn--pill btn-danger m-btn m-btn--custom">
            Prekliči
        </button>

        <button (click)="confirm()" type="buttons" class="mr-auto btn m-btn--pill btn-accent m-btn m-btn--custom">Potrdi</button>
    </div>
</form>
